"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abstractRefiners_1 = require("../abstractRefiners");

var mergingCalculation_1 = require("../../calculation/mergingCalculation");

var ENMergeDateTimeRefiner = /*#__PURE__*/function (_abstractRefiners_1$M) {
  _inherits(ENMergeDateTimeRefiner, _abstractRefiners_1$M);

  var _super = _createSuper(ENMergeDateTimeRefiner);

  function ENMergeDateTimeRefiner() {
    _classCallCheck(this, ENMergeDateTimeRefiner);

    return _super.apply(this, arguments);
  }

  _createClass(ENMergeDateTimeRefiner, [{
    key: "shouldMergeResults",
    value: function shouldMergeResults(textBetween, currentResult, nextResult) {
      return (currentResult.start.isOnlyDate() && nextResult.start.isOnlyTime() || nextResult.start.isOnlyDate() && currentResult.start.isOnlyTime()) && textBetween.match(this.patternBetween()) != null;
    }
  }, {
    key: "mergeResults",
    value: function mergeResults(textBetween, currentResult, nextResult) {
      var result = currentResult.start.isOnlyDate() ? mergingCalculation_1.mergeDateTimeResult(currentResult, nextResult) : mergingCalculation_1.mergeDateTimeResult(nextResult, currentResult);
      result.index = currentResult.index;
      result.text = currentResult.text + textBetween + nextResult.text;
      return result;
    }
  }]);

  return ENMergeDateTimeRefiner;
}(abstractRefiners_1.MergingRefiner);

exports.default = ENMergeDateTimeRefiner;